import React, { useCallback, useState } from 'react';
import { AppBar, Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TabPanel from 'src/components/TabPanel/TabPanel';
import { useDispatch, useSelector } from 'react-redux';
import { selectBusinessQueryOptions } from 'src/store/selectors/businessSelectors';
import { loadBusinessMetricsByPeriod } from 'src/store/actions/businessActions';
import { MetricsViewOptions } from 'src/utils/constants/business';
import MetricsByPeriodTabsList from './MetricsByPeriodTabsList';

const selectMetricsOptions = value => {
  switch (Number(value)) {
    case 0:
      return MetricsViewOptions.DISTRIBUTOR;
    case 1:
      return MetricsViewOptions.KAM;
    default:
      return MetricsViewOptions.DISTRIBUTOR;
  }
};

const MetricsTabsList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const queryOpts = useSelector(selectBusinessQueryOptions);
  const [tabIndex, setTabIndex] = useState(0);

  const handleChange = useCallback(
    (_, newValue) => {
      setTabIndex(newValue);
      const metricsViewOption = selectMetricsOptions(newValue);
      dispatch(
        loadBusinessMetricsByPeriod({
          metricsViewOption,
          sort: {},
          page: 0
        })
      );
    },
    [setTabIndex, dispatch, queryOpts]
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar
        variant="outlined"
        position="static"
        sx={{
          border: 'none',
          borderBottom: '1px solid rgba(43,45,66,0.1)',
          background: 'transparent',
          flexDirection: 'row'
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          value={tabIndex}
          onChange={handleChange}
        >
          <Tab label={t('NAVIGATION.DISTRIBUTOR')} />
          <Tab label={t('COMMON.KAM')} />
        </Tabs>
      </AppBar>

      <TabPanel value={tabIndex} index={0}>
        <MetricsByPeriodTabsList />
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        <MetricsByPeriodTabsList />
      </TabPanel>
    </Box>
  );
};

export default MetricsTabsList;
